import { MergeCandidatesRequestSchema, MergeCandidatesResponseSchema } from './merge-candidates.schema';
/**
 * Merge Candidates Endpoint Contract
 * Lists completed step recordings eligible for merging with a pending assignment
 */ export const mergeCandidatesContract = {
    method: 'GET',
    path: '/api/v2/process-step-recording/merge-candidates',
    description: 'List completed step recordings eligible for merging',
    requestSchema: MergeCandidatesRequestSchema,
    responseSchema: MergeCandidatesResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=merge-candidates.contract.js.map